import React from "react";
import { BrowserRouter as Router } from "react-router-dom";
import { CookiesProvider } from "react-cookie";
import { AuthProvider } from "hooks/useAuth";
import AppRoutes from "AppRoutes";
import ScrollToTop from "components/ScrollToTop/ScrollToTop";
import "./styles/global.css";

function App() {
  return (
    <CookiesProvider>
      <AuthProvider>
        <Router>
          <ScrollToTop />
          <AppRoutes />
        </Router>
      </AuthProvider>
    </CookiesProvider>
  );
}

export default App;
